import apiService from './apiService';

export const productService = {
    create: (data) => apiService.post('/products', data),
    getAll: () => apiService.get('/products'),
    getByCompany: (companyId) => apiService.get(`/products/company/${companyId}`),
    getById: (id) => apiService.get(`/products/${id}`),
    update: (id, data) => apiService.put(`/products/${id}`, data),
    delete: (id) => apiService.delete(`/products/${id}`)
};
